import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogClose,
  DialogContent,
  Icon,
} from "@tenant/ui";
import styles from "./OfferDialog.module.scss";

export interface OfferDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  ctaLabel: string;
  onCta?: () => void;
  sponsorLogoUrl?: string;
  sponsorLogoAlt?: string;
  sponsorName?: string;
}

export const OfferDialog = ({
  open,
  onOpenChange,
  title,
  description,
  ctaLabel,
  onCta,
  sponsorLogoUrl,
  sponsorLogoAlt,
  sponsorName,
}: OfferDialogProps) => {
  const [block, cn] = useModuleBEM(styles, "OfferDialog");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={block}
        title={title}
        titleIsVisuallyHidden
        bottomFixedContent={
          <DialogClose asChild>
            <Button
              className={cn("cta")}
              buttonType={ButtonTypeEnum.Primary}
              onClick={onCta}
            >
              {ctaLabel}
            </Button>
          </DialogClose>
        }
      >
        <div className={cn("header")}>
          <div className={cn("icon-container")}>
            <Icon iconName={IconNameEnum.offers__tag} />
          </div>
          <div className={cn("text")}>
            <p className={cn("title")}>{title}</p>
            <p className={cn("description")}>{description}</p>
          </div>
        </div>
        <div className={cn("footer")}>
          <div className={cn("sponsor")}>
            {sponsorLogoUrl && (
              <img
                className={cn("sponsor-logo")}
                src={sponsorLogoUrl}
                alt={sponsorLogoAlt ?? ""}
              />
            )}
            {sponsorName && <p className={cn("sponsor-name")}>{sponsorName}</p>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
